export default {
  'groups.list.header.description': 'Descrição do Grupo',
  'groups.list.header.area': 'Área',
  'groups.list.header.actions': 'Ações',
  'groups.list.column.actions.button': 'Ver/Editar',
  'groups.searchBar.button.generateReport': 'Gerar Relatório',
  'groups.searchBar.button.newGroup': 'Novo Grupo',
  'groups.general.form.description': 'Descrição do Grupo',
  'subGroups.general.form.description': 'Descrição do SubGrupo',
  'groups.general.form.area': 'Área',
  'groups.general.form.subGroup': 'Descrição do sub grupo',
  'groups.general.form.subGroupRemove': 'Excluir Sub Grupo',
  'groups.general.form.subGroupAdd': 'Adicionar Sub Grupo',
  'groups.general.form.save': 'Salvar',
  'groups.general.form.removeGroup': 'Excluir Grupo',
  'groups.create.notification.success': 'Sucesso',
  'groups.create.notification.successDescription': 'Grupo criado.',
  'groups.remove.modal.title': 'Deseja realmente excluir o grupo?',
  'groups.remove.modal.content': `
    Ao excluir o grupo, todos os sub-grupos associados a ele serão removidos. 
    Essa ação não pode ser revertida.
  `,
  'groups.remove.modal.button.ok': 'Excluír',
  'groups.remove.notification.success': 'Sucesso',
  'groups.remove.notification.successDescription': 'Grupo removido.',
  'groups.subgroups': 'Sub-Grupos',
  'groups.subgroups.create': 'Criar Novo Sub-Grupo',
  'groups.subgroups.create.notification.success': 'Sucesso',
  'groups.subgroups.create.notification.successDescription':
    'Sub-Grupo criado.',
  'groups.subgroups.update': 'Atualizar Sub-Grupo',
  'groups.subgroups.update.notification.success': 'Sucesso',
  'groups.subgroups.update.notification.successDescription':
    'Sub-Grupo atualizado.',
  'groups.subgroups.remove.modal.title': 'Excluir Sub-Grupo',
  'groups.subgroups.remove.modal.content': 'Deseja excluir o sub-grupo?',
  'groups.subgroups.remove.modal.button.ok': 'Excluir',
  'groups.subgroups.remove.modal.message.success': 'Sub-Grupo removido!',
  'groups.subgroups.remove.modal.message.error':
    'Não foi possível remover o sub-grupo.',
  'groups.subgroups.remove.notification.success': 'Sucesso',
  'groups.subgroups.remove.notification.successDescription':
    'Sub-Grupo removido.',
  'groups.update.notification.success': 'Grupo atualizado com sucesso!',
  'groups.update.notification.successDescription':
    'As informações do grupo foram atualizadas.',

  'groups.modal.report.title': 'Gerar Relatório',
  'groups.modal.report.buttons.viewReport': 'Visualizar Relatório',
  'groups.modal.report.buttons.pdf': 'Gerar PDF',
  'groups.modal.report.buttons.rtf': 'Gerar RTF',
  'groups.modal.report.buttons.csv': 'Gerar CSV',
  'groups.modal.report.form.description': 'Descrição',
  'groups.modal.report.form.areas': 'Áreas',
  'groups.notification.generate.report.title': 'Relatório gerado com sucesso',
  'groups.notification.generate.report.description':
    'Relatório de Estoque por Grupos Gerado com Sucesso!',

  'groups.error.remove.bonds':
    'Não foi possível concluir a ação devido a violação nos vínculos desse registro!',
  'groups.subGroups.error.remove.bonds':
    'Não foi possível concluir a ação devido a violação nos vínculos desse registro!',

  'groups.status.message.success': 'Status do Grupo alterado com sucesso!',
};
